import BaseCard from "../../../components/ui/BaseCard";
import { UserType } from "../../../utils/enum";

const Pay = ({ payment, authRole }) => {
  return (
    <>
      <BaseCard className="pt-4 pb-3  xl:px-56 md:px-16 px-5 rounded-lg !mb-[0px]" elevation={1}>
        <div className="flex items-center pb-1">
          <h6 className="text-dark">Payment Terms</h6>

          <span className="text-xs ml-3 text-[#686868]">
            ({payment?.engineerRates?.paymentType === "HOURLY" && "Hourly"}
            {payment?.engineerRates?.paymentType === "HALF_DAY" && "Half Day"}
            {payment?.engineerRates?.paymentType === "FULL_DAY" && "Full Day"}
            {payment?.engineerRates?.paymentType === "FIXED" && "Fixed"}
            {authRole === UserType.CLIENT &&
              payment?.engineerRates?.paymentType === "FTH" &&
              "First two hours"}
            {authRole === UserType.FREELANCER &&
              payment?.engineerRates?.paymentType === "FTH" &&
              "Hourly"}
            )
          </span>
        </div>

        <p>
          Payment for this work order will be processed{" "}
          <span className="text-secondary font-medium">{payment?.engineerRates?.paymentTerms}</span>{" "}
          after the job is completed. If there are any issues related to the work, you will be
          notified within <span className="text-secondary font-medium">Seven days</span>.
        </p>
      </BaseCard>
    </>
  );
};

export default Pay;
